import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class DateOrderSelectController implements angular.IComponentController {
    isDisabled: boolean;
    model: string[];
    propertyName: string;

    static $inject = [];
}

export const wtDateOrderSelect: ComponentDefinition = {
    componentId: 'wtDateOrderSelect',
    controller: DateOrderSelectController,
    template: require('./dateOrderSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        isDisabled: '<',
        model: '=',
        propertyName: '<'
    }
};
